<ng-container *ngIf="vo$ | async; let vo">
	<app-panel
		headerHeight="3rem"
		isAlwaysOpen="true"
		hasSearchableGrid="true"
		hasRefresh="true"
		[actions]="vo.userPermissions.has(ElementPermission.Edit) ? profileActions : []"
		[itemsCount]="vo.profileList.elements.size"
		(search)="search($event)"
		(refresh)="refresh()">
		<div
			class="app-panel__title"
			panel-title>
			<mat-icon [svgIcon]="DcIcons.Profile"></mat-icon>
			<span
				i18n="@@subscription.profile.list.title">
				profiles</span>
		</div>

		<dx-data-grid
			#profileGrid
			keyExpr="id"
			[elementAttr]="{id: 'subscription-profile-list',class: 'app-subscription-profile-list'}"
			[dataSource]="vo.profileList.elements | toArray"
			[hoverStateEnabled]="true"
			[showColumnHeaders]="true"
			[allowColumnResizing]="true"
			[columnAutoWidth]="false"
			[showRowLines]="false"
			[showColumnLines]="false"
			[rowAlternationEnabled]="false"
			[showBorders]="false"
			[width]="'100%'"
			(onCellHoverChanged)="onCellHover($event)"
			(onSelectionChanged)="selectProfile($event)"
			(onContentReady)="onGridReady()"
			(onRowPrepared)="onRowPrepared($event)">

			<dxo-load-panel
				shadingColor="rgba(0,0,0,0)"
				[indicatorSrc]="DcLoaders.LoaderInfinite"
				[height]="100"
				[width]="100"
				[enabled]="true"
				[showIndicator]="true"
				[showPane]="true"
				[shading]="true"></dxo-load-panel>

			<dxo-selection
				[mode]="vo.mode === 'STANDALONE' ? 'none': 'single'"></dxo-selection>

			<!-- Fixable in position columns	-->
			<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

			<ng-container
				*ngFor="let col of vo.profileList.availableColumns | toArray">
				<dxi-column
					*ngIf="col.field === 'label'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="true"
					[dataType]="col.type"
					[alignment]="'left'"
					[width]="'20%'"
					[visibleIndex]="col.visibleIndex"
					cellTemplate="labelTemplate"></dxi-column>
				<dxi-column
					*ngIf="col.field === 'description'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable ?? false"
					[allowSorting]="true"
					[dataType]="col.type"
					[alignment]="'left'"
					[width]="'25%'"
					[visibleIndex]="col.visibleIndex"></dxi-column>
				<dxi-column
					*ngIf="col.field === 'columnModelId'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="false"
					[alignment]="'left'"
					[width]="'20%'"
					[visibleIndex]="col.visibleIndex"
					cellTemplate="columnModelTemplate"></dxi-column>
				<dxi-column
					*ngIf="col.field === 'filterModelIds'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="false"
					[alignment]="'left'"
					[width]="'10%'"
					[visibleIndex]="col.visibleIndex"
					cellTemplate="filterTemplate"></dxi-column>
				<!--<dxi-column
					*ngIf="col.field === 'projects'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="false"
					[alignment]="'left'"
					[width]="'10%'"
					[visibleIndex]="col.visibleIndex"
					cellTemplate="projectsTemplate"></dxi-column>-->
				<dxi-column
					*ngIf="col.field === 'status'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="false"
					[allowHiding]="false"
					[allowGrouping]="false"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="false"
					[alignment]="'left'"
					[width]="'10%'"
					[visibleIndex]="col.visibleIndex"
					cellTemplate="statusTemplate"></dxi-column>
			</ng-container>

			<dxi-column
				[fixed]="false"
				[allowResizing]="false"
				[allowHiding]="false"
				[allowGrouping]="false"
				[allowSearch]="false"
				[allowSorting]="false"
				[alignment]="'left'"
				[visible]="vo.mode === 'STANDALONE'
						&& vo.userPermissions.has(ElementPermission.Edit)"
				[visibleIndex]="vo.profileList.availableColumns.size"
				[width]="'15%'"
				[showInColumnChooser]="false"
				cellTemplate="actionsTemplate"></dxi-column>

			<div *dxTemplate="let cell of 'labelTemplate'" class="label-template">
				<mat-icon
					*ngIf="!cell.data['isInSync'] && vo.subscriptionStatus === SubscriptionStatus.Available"
					matTooltip="My tooltip"
					i18n-matTooltip="@@general.status.not-synced"
					[svgIcon]="DcIcons.NotSynced"></mat-icon>
				<span
					[matTooltip]="cell.data['label']"
					[matTooltipDisabled]="cell.data['label'].length <= 30"
					matTooltipPosition="right">
					{{cell.data['label'] | truncate: 30 : 1 : 'end'}}</span>
			</div>

			<div class="columns-count" *dxTemplate="let cell of 'columnModelTemplate'">
				<div class="profile-list__columns"
						 *ngIf="vo.profilesColumnModels.get(cell.key) as profileColumnModel">
					<app-overlay-badge
						*ngIf="profileColumnModel.columns.size !== 0"
						[icon]="ComponentIcons.Column"
						[value]="profileColumnModel.columns.size"
						[active]="true"
						[isOpen]="vo.openedOverlayProfile.profileId === cell.key"
						(overlayDismiss)="closeColumnsPopover()"
						(click)="openColumnsPopover($event, cell.key)">
						<app-popover
							overlayContent
							label="columns"
							i18n-label="@@subscription.profile.list.column.columns"
							[icon]="{ iconName: ComponentIcons.Column }"
							[count]="profileColumnModel.columns.size"
							(adbPopoverClose)="closeColumnsPopover()">
							<div class="columns-details">
								<ng-container *ngFor="let column of profileColumnModel.columns | toArray">
									<app-column-type
										[type]="column['type']"
										[isList]="column['isList']"></app-column-type>
									<span>{{ column.label }}</span>

									<mat-icon
										*ngIf="column['isHashed']; else emptyIcon"
										[svgIcon]="DcIcons.Encrypted">
									</mat-icon>

									<ng-template #emptyIcon>
										<span></span>
									</ng-template>
								</ng-container>
							</div>
						</app-popover>
					</app-overlay-badge>
					<span
						[matTooltip]="profileColumnModel.label"
						[matTooltipDisabled]="profileColumnModel.label.length <= 30"
						matTooltipPosition="right">
					{{profileColumnModel.label| truncate: 30 : 1 : 'end'}}</span>
				</div>
			</div>

			<div *dxTemplate="let cell of 'filterTemplate'">
				<app-overlay-badge
					data-style-override
					class="inactive"
					[icon]="cell.data['filterModelIds'].size !== 0 ? ComponentIcons.Filter : ComponentIcons.FilterOff"
					[value]="cell.data['filterModelIds'].size"
					[active]="true"
					[isOpen]="false">
					<app-popover
						overlayContent
						label="projects"
						i18n-label="@@subscription.profile.list.column.filters"
						[icon]="{ iconName: ComponentIcons.Filter }"
						[count]="cell.data['filterModelIds'].size">
					</app-popover>
				</app-overlay-badge>
			</div>

			<!--<div *dxTemplate="let cell of 'projectsTemplate'">
				<app-overlay-badge
					*ngIf="cell.data['projects'].size !== 0"
					[icon]="ComponentIcons.Project"
					[value]="cell.data['projects'].size"
					[active]="true"
					[isOpen]="false">
					<app-popover
						overlayContent
						label="projects"
						i18n-label="@@subscription.profile.list.column.projects"
						[icon]="{ iconName: ComponentIcons.Project }"
						[count]="cell.data['projects'].size">
					</app-popover>
				</app-overlay-badge>
			</div>-->

			<div *dxTemplate="let cell of 'statusTemplate'">
				<div *ngIf="cell.data['status'] === ColumnStatus.Warning"
						 class="status-badge warning">
					<mat-icon
						[svgIcon]="DcIcons.Warning"></mat-icon>
					<span
						i18n="@@subscription.column.deleted">
						deleted</span>
				</div>
			</div>

			<div
				*dxTemplate="let cell of 'actionsTemplate'"
				[hidden]="cell.rowIndex !== currentlyHovered">
				<div class="actions-template">
					<button
						mat-icon-button
						class="actions-template__menu-btn"
						matTooltip="simulate"
						i18n-matTooltip="@@subscription.profile.list.action.simulate"
						matTooltipPosition="left"
						(click)="simulateProfile(cell.data)">
						<mat-icon [svgIcon]="DcIcons.TestApi"></mat-icon>
					</button>

					<button
						mat-icon-button
						class="actions-template__menu-btn"
						matTooltip="update"
						i18n-matTooltip="@@subscription.profile.list.action.update"
						matTooltipPosition="left"
						(click)="openProfileModal(cell.data)">
						<mat-icon [svgIcon]="ActionIcons.Update"></mat-icon>
					</button>

					<button
						mat-icon-button
						class="actions-template__menu-btn"
						matTooltip="delete"
						i18n-matTooltip="@@subscription.profile.list.action.delete"
						matTooltipPosition="left"
						(click)="deleteProfile(cell.data)">
						<mat-icon [svgIcon]="ActionIcons.Delete"></mat-icon>
					</button>
				</div>
			</div>

			<!-- Sorting	-->
			<dxo-sorting mode="multiple"></dxo-sorting>

			<!-- Pagination -->
			<dxo-paging [pageSize]="10"></dxo-paging>

			<dxo-pager [visible]="true"></dxo-pager>

			<!-- Filterable columns	-->
			<dxo-header-filter [visible]="true"></dxo-header-filter>

			<dxo-filter-row [visible]="true"></dxo-filter-row>

		</dx-data-grid>
	</app-panel>
</ng-container>
